import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BASE_URL } from "../../constants";
import Header from "../Helper/Header";
import NewFooter from "../Helper/NewFooter";
import ContactForm from "../../components/ContactForm/ContactForm";
const EngineeringFirms = () => {
  return (
    <>
      <Header />
      <Container fluid>
        {/* Heading 1 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h1 className="heading1">Empowering </h1>
          </Col>
        </Row>

        {/* Heading 2 */}
        <Row className="justify-content-center">
          <Col className="text-center">
            <h2 className="heading2">
              Engineering & <br />
              Consulting Firms
            </h2>
          </Col>
        </Row>

        {/* First Grid */}
        <div>
          <Row className="justify-content-center align-items-end">
            {" "}
            {/* Add align-items-end here */}
            <Col md={4} className="left-box">
              <div className="leftboxtext">
                Engineering and consulting firms play a critical role in guiding
                industries toward efficiency, sustainability, and innovation.
                However, traditional analysis tools often lack the speed,
                accuracy, and flexibility needed to evaluate complex scenarios
                and drive actionable insights. Dsider equips engineering and
                consulting firms with powerful digital simulations, financial
                modeling, and sustainability analytics—delivering more value to
                clients while enhancing their own operational efficiency and
                long-term sustainability.{" "}
              </div>
            </Col>
            <Col md={8} className="d-flex align-items-end">
              {" "}
              {/* Add d-flex and align-items-end here */}
              <img
                src={`${BASE_URL}solutions/consulting_firms.png`}
                alt="Climate Tech"
                className="right-image"
              />
            </Col>
          </Row>
        </div>

        {/* Second Grid */}
        <div className="container " style={{ marginTop: "6rem" }}>
          <Row className="d-flex justify-content-center align-items-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/digital_twin_ simulations.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Enhance Decision-Making with Digital Twin Simulations{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Create a virtual replica of your operations to test
                  improvements before implementation.
                </li>
                <li>
                  Test multiple scenarios in a risk-free environment before
                  recommending solutions.{" "}
                </li>
                <li>
                  Optimize designs, workflows, and sustainability strategies
                  with AI-driven insights.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/carbon_footprint.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Accelerate Sustainability Consulting
              </h3>
              <ul className="innovation-list">
                <li>
                  Detailed carbon footprint analysis across industries and
                  operations.{" "}
                </li>
                <li>
                  Actionable insights for emission reduction and compliance.
                </li>
                <li>
                  A streamlined approach to measuring and validating
                  sustainability efforts.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/cost_benefit_ analysis.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Drive Better Client Outcomes with Financial & Risk Analysis{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Comprehensive cost-benefit analysis for sustainable project
                  investments.{" "}
                </li>
                <li>
                  Risk assessments to identify and mitigate operational,
                  environmental, and financial challenges.{" "}
                </li>
                <li>
                  Data-driven insights to support strategic decision-making for
                  clients.{" "}
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={4}>
              <img
                src={`${BASE_URL}solutions/complex_datasets.png`}
                alt="Power"
                className="power-image"
              />{" "}
            </Col>
            <Col md={8}>
              <h3 className="innovation-heading">
                Seamless Data Integration for Smarter Consulting{" "}
              </h3>
              <ul className="innovation-list">
                <li>
                  Consolidate complex datasets into a single, easy-to-use
                  platform.{" "}
                </li>
                <li>
                  Leverage AI-powered analytics to enhance reporting and
                  recommendations.{" "}
                </li>
                <li>
                  Provide real-time insights to clients for proactive
                  decision-making.
                </li>
                {/* Add 2 more list items here */}
              </ul>
            </Col>
          </Row>
        </div>

        {/* Action Box */}
        <Row className="justify-content-center">
          <Col
            className="action-box"
            style={{
              display: "grid",
              gridTemplateRows: "auto 1fr",
              alignItems: "start",
              justifyItems: "start",
            }}
          >
            <h4 className="action-heading">
              Achieve your Net Zero <br /> Goals Faster with <br /> Dsider
            </h4>
            <p
              className="action-textEng"
              style={{ justifySelf: "end", alignSelf: "end" }}
            >
              With Dsider, engineering and consulting firms can move beyond
              spreadsheets and manual calculations to deliver faster, more
              accurate, and more impactful sustainability solutions. Whether
              you're advising on industrial efficiency, energy transition, or
              carbon reduction, our platform helps you provide clients with the
              data, insights, and strategies they need to succeed.
            </p>
          </Col>
        </Row>
      </Container>
      <ContactForm showFooter={false}/>
      <NewFooter />
    </>
  );
};

export default EngineeringFirms;
